import type { ReactNode } from 'react';

import { ListItemIcon, ListItemText, Menu, MenuItem } from '../components';

type MenuAnchorOrigin = {
  vertical: 'top' | 'center' | 'bottom';
  horizontal: 'left' | 'center' | 'right';
};

export type DropdownMenuItem = {
  id: string;
  label: string;
  icon?: ReactNode;
  onClick: () => void;
  disabled?: boolean;
};

type Props = Readonly<{
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  items: DropdownMenuItem[];
  anchorOrigin?: MenuAnchorOrigin;
  transformOrigin?: MenuAnchorOrigin;
}>;

const defaultAnchorOrigin: MenuAnchorOrigin = {
  vertical: 'bottom',
  horizontal: 'right'
};

const defaultTransformOrigin: MenuAnchorOrigin = {
  vertical: 'top',
  horizontal: 'right'
};

export const DropdownMenu = ({
  anchorEl,
  open,
  onClose,
  items,
  anchorOrigin = defaultAnchorOrigin,
  transformOrigin = defaultTransformOrigin
}: Props) => {
  const renderedItems = items.map(item => (
    <MenuItem key={item.id} onClick={item.onClick} disabled={item.disabled}>
      {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
      <ListItemText>{item.label}</ListItemText>
    </MenuItem>
  ));

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
    >
      {renderedItems}
    </Menu>
  );
};
